import {NgModule} from '@angular/core';
import {HtmlWithVariablesToTextPipe} from './html-with-variables-to-text.pipe';

@NgModule({
  exports: [HtmlWithVariablesToTextPipe],
  declarations: [HtmlWithVariablesToTextPipe],
  providers: [HtmlWithVariablesToTextPipe]
})
export class HtmlWithVariablesToTextPipeModule {}
